import { useState } from "react";
import { Link } from "react-router-dom";
import "./Carousel.css";

function Carousel({ images, className }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const slides = images.map((image) => (typeof image === "string" ? { src: image } : image));

    function updateCarousel(index) {
        const offset = -index * 100;
        document.querySelector(".carousel").style.transform = `translateX(${offset}%)`;
    }

    function prevSlide() {
        const newIndex = (currentIndex > 0) ? currentIndex - 1 : slides.length - 1;
        setCurrentIndex(newIndex);
        updateCarousel(newIndex);
    }

    function nextSlide() {
        const newIndex = (currentIndex < slides.length - 1) ? currentIndex + 1 : 0;
        setCurrentIndex(newIndex);
        updateCarousel(newIndex);
    }

    return (
        <div className={className}>
            <div className="carousel">
                {slides.map((slide, index) => {
                    const image = <img src={slide.src} alt={slide.alt || `Slide ${index + 1}`} />;
                    return slide.href ? (
                        <Link key={index} to={slide.href} className="carousel-slide-link">
                            {image}
                        </Link>
                    ) : (
                        <div key={index} className="carousel-slide">{image}</div>
                    );
                })}
            </div>
            {slides.length > 1 && (
                <div className="carousel-buttons">
                    <button className="carousel-btn prev" onClick={prevSlide}>&#10094;</button>
                    <button className="carousel-btn next" onClick={nextSlide}>&#10095;</button>
                </div>
            )}
        </div>
    );
}

export default Carousel;